import { render } from "./App.vue?vue&type=template&id=689f0c88"
const script = {}

import "./App.vue?vue&type=style&index=0&id=689f0c88&lang=scss"

import exportComponent from "/opt/homebrew/var/www/zsplus_channel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__